import { defineMessages } from "react-intl";
export default defineMessages({
    astronomicalSunPhase: {
        id: "astral.astronomicalSunPhase",
        defaultMessage: "Astronomical {sunPhase}",
    },
    civilSunPhase: {
        id: "astral.civilSunPhase",
        defaultMessage: "Civil {sunPhase}",
    },
    dawn: {
        id: "astral.dawn",
        defaultMessage: "Dawn",
    },
    dusk: {
        id: "astral.dusk",
        defaultMessage: "Dusk",
    },
    firstQuarter: {
        id: "astral.firstQuarter",
        defaultMessage: "First quarter",
    },
    fullMoon: {
        id: "astral.fullMoon",
        defaultMessage: "Full moon",
    },
    lastQuarter: {
        id: "astral.lastQuarter",
        defaultMessage: "Last quarter",
    },
    moon: {
        id: "astral.moon",
        defaultMessage: "Moon",
    },
    moonPhases: {
        id: "astral.moonPhases",
        defaultMessage: "Moon phases",
    },
    moonrise: {
        id: "astral.moonrise",
        defaultMessage: "Moonrise",
    },
    moonset: {
        id: "astral.moonset",
        defaultMessage: "Moonset",
    },
    nauticalSunPhase: {
        id: "astral.nauticalSunPhase",
        defaultMessage: "Nautical {sunPhase}",
    },
    newMoon: {
        id: "astral.newMoon",
        defaultMessage: "New moon",
    },
    noon: {
        id: "astral.noon",
        defaultMessage: "Noon",
    },
    remainingDaylight: {
        id: "astral.remainingDaylight",
        defaultMessage: "Remaining daylight",
    },
    sunrise: {
        id: "astral.sunrise",
        defaultMessage: "Sunrise",
    },
    sunriseAndSunset: {
        id: "astral.sunriseAndSunset",
        defaultMessage: "Sunrise and sunset",
    },
    sunset: {
        id: "astral.sunset",
        defaultMessage: "Sunset",
    },
    totalDaylight: {
        id: "astral.totalDaylight",
        defaultMessage: "Total daylight",
    },
    waningCrescent: {
        id: "astral.waningCrescent",
        defaultMessage: "Waning crescent",
    },
    waningGibbous: {
        id: "astral.waningGibbous",
        defaultMessage: "Waning gibbous",
    },
    waxingCrescent: {
        id: "astral.waxingCrescent",
        defaultMessage: "Waxing crescent",
    },
    waxingGibbous: {
        id: "astral.waxingGibbous",
        defaultMessage: "Waxing gibbous",
    },
});
